import React from "react";
import BulkUploadDriverPolygonId from "../../components/BulkUploadDriverPolygonId";

const BulkUploadDriverPolygonIdManager = (props) => {
    return <BulkUploadDriverPolygonId />;
};

export default BulkUploadDriverPolygonIdManager;